import { useTranslation } from 'react-i18next';

import { PLATFORM_THEME_COLORS, Typography } from '@thinknet-gmbh/platform-common-ui';

import { formatByMask, getTimezoneValue } from 'src/common/helpers/common.helpers';

import { MainContainer, UserInfoContainer, UserInfoElement } from './user-info-view.styles';

const UserInfoView = ({ data }: { data: any }) => {
  const { t } = useTranslation(['common', 'settings']);
  const { profile, account } = data;

  const timezone: string | undefined = getTimezoneValue(data?.profile || {});

  return (
    <MainContainer>
      <UserInfoContainer>
        <UserInfoElement>
          <Typography weight="bold">{`${t('common:labels.firstName')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {profile.firstName}
          </Typography>
        </UserInfoElement>
        <UserInfoElement>
          <Typography weight="bold">{`${t('common:labels.lastName')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{profile.lastName}</Typography>
        </UserInfoElement>
        <UserInfoElement>
          <Typography weight="bold">{`${t('common:labels.phoneNumber')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {formatByMask(profile.phoneNumber, '+## ### ### #######')}
          </Typography>
        </UserInfoElement>
        <UserInfoElement>
          <Typography weight="bold">{`${t('common:labels.email')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{account.email}</Typography>
        </UserInfoElement>
      </UserInfoContainer>

      <UserInfoContainer>
        <UserInfoElement>
          <Typography weight="bold">{`${t('settings:company.labels.companyName')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {account.companyName}
          </Typography>
        </UserInfoElement>
        <UserInfoElement>
          <Typography weight="bold">{`${t(
            'settings:userProfileSettings.labels.department'
          )}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {account.department}
          </Typography>
        </UserInfoElement>
        <UserInfoElement>
          <Typography weight="bold">{`${t(
            'settings:userProfileSettings.labels.jobTitle'
          )}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{account.jobTitle}</Typography>
        </UserInfoElement>
        <UserInfoElement>
          <Typography weight="bold">{`${t(
            'settings:userProfileSettings.labels.inObeysOf'
          )}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {account.managerName}
          </Typography>
        </UserInfoElement>
      </UserInfoContainer>

      <UserInfoContainer>
        <UserInfoElement>
          <Typography weight="bold">{`${t('common:labels.permission')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {account.permissionGroup}
          </Typography>
        </UserInfoElement>
        <UserInfoElement>
          <Typography weight="bold">{`${t('common:labels.language')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {t(`languages.${profile.language}`)}
          </Typography>
        </UserInfoElement>
        <UserInfoElement>
          <Typography weight="bold">{`${t('common:labels.timeZone')}:`}</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{timezone || '-'}</Typography>
        </UserInfoElement>
      </UserInfoContainer>
    </MainContainer>
  );
};

export default UserInfoView;
